import { render, staticRenderFns } from "./CloseTabModal.vue?vue&type=template&id=4c645ff3"
import script from "./CloseTabModal.vue?vue&type=script&lang=ts"
export * from "./CloseTabModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports